import { Settings as LayoutSettings } from '@ant-design/pro-layout';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
} = {
  // layout: 'mix',
  // navTheme: 'light',
  layout: 'side',
  navTheme: 'dark',
  headerTheme: 'light',
  fixSiderbar: true,
  menuHeaderRender: undefined,
  primaryColor: 'rgba(41, 97, 255, 1)',
  contentWidth: 'Fluid',
  fixedHeader: false,
  colorWeak: false,
  title: 'BlueGrowth Cloud Admin',
  pwa: false,
  iconfontUrl: '',
};

export default Settings;
